module.exports = __webpack_public_path__ + "static/media/Tick.46da467d.svg";